import React, { useState, useEffect } from "react";
import "./Switch.scss";
import UtilServices from "@services/UtilServices";

export default function Switch(props) {
  const [selecionado, setSelecionado] = useState(props.default);
  const [lstSwitch, setLstSwitch] = useState([]);

  useEffect(() => {
    setLstSwitch(
      props.lstSwitch.map((item, index) => ({
        ...item,
        id: index,
      })),
    );
  }, [props.lstSwitch]);

  useEffect(() => {
    handleChangeLstSwitch();
  }, []);

  function handleChangeLstSwitch() {
    let lst = props.lstSwitch.map((item, index) => ({
      ...item,
      id: index,
    }));

    setLstSwitch(lst);

    props.setRetorno({
      ...lst[selecionado],
    });
  }

  function onRetorno(item, key) {
    setSelecionado(key);
    props.setRetorno({
      ...item,
    });
  }

  return (
    <div
      className={`switch ${props.className} button${lstSwitch[selecionado]?.id}`}
    >
      {props.title && <p>{props.title}</p>}
      {lstSwitch.map((item, key) => (
        <div
          key={key}
          className="switch-nselecao"
          onClick={() => onRetorno(item, key)}
        >
          {props.icon ? item.button : UtilServices.stringToJsx(item.button)}
        </div>
      ))}

      {/* Único elemento que se move suavemente */}
      <div className={`switch-selecao button${lstSwitch[selecionado]?.id}`}>
        {props.icon
          ? lstSwitch[selecionado]?.button
          : UtilServices.stringToJsx(lstSwitch[selecionado]?.button)}
      </div>
    </div>
  );
}

Switch.defaultProps = {
  lstSwitch: [{ button: "ativo" }, { button: "inativo" }, { button: "todos" }],
  className: "",
  setRetorno: () => null,
  onClick: () => null,
  theme: "1",
  disabled: false,
  title: "",
  default: 0,
};
